// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"94afba12","753":"5e4f865a"}[chunkId] + ".chunk.css";
};